var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.showTip && _vm.tip)?_c('s-tooltip',{attrs:{"transfer":true,"content":_vm.tip,"placement":"bottom"}},[_vm._t("content")],2):_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }